import { render, staticRenderFns } from "./curriculum_item.vue?vue&type=template&id=f8929bb6&scoped=true&"
import script from "./curriculum_item.vue?vue&type=script&lang=js&"
export * from "./curriculum_item.vue?vue&type=script&lang=js&"
import style0 from "./curriculum_item.vue?vue&type=style&index=0&id=f8929bb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8929bb6",
  null
  
)

export default component.exports